import moment from 'moment';

function parse(str) {
  const parsed = moment.utc(str, ['D.M.YYYY', 'DD.MM.YYYY'], true);
  return parsed.isValid() ? parsed.toDate() : undefined;
}

function fromJson(str) {
  return moment.utc(str).local().toDate();
}

function formatUTC(date) {
  return moment(date).format("YYYY-MM-DD");
}

function format(date) {
  return moment(date).format("DD.MM.YYYY");
}

function formatMonth(date) {
  return moment(date).format("MM.YYYY");
}

function formatDateTime(date) {
  return moment.utc(date).local().format("DD.MM.YYYY - H.mm");
}

function formatNoDelim(date) {
  return moment(date).format("YYYYMMDDHHmm");
}

function getStartOf({year, month}) {
  // madness? no, in moment, months are from 0-11
  return moment([year, month-1]).startOf('month');
}

function getEndOf({year, month}) {
  // madness? no, in moment, months are from 0-11
  return moment([year, month-1]).endOf('month');
}

function getDateClosestToNow(from, to) {
  const now = moment();
  if (now.isSameOrAfter(from)) {
      if (now.isSameOrBefore(to)) {
          return now.toDate();
      }
      return moment(to).toDate();
  }
  return moment(from).toDate();
}


export default { format, formatDateTime, formatMonth, formatUTC, fromJson, parse, formatNoDelim, getStartOf, getEndOf, getDateClosestToNow };



// WEBPACK FOOTER //
// ./modules/issFrontend/utils/dates.js